interface PayloadConvertorProps {
  lab?: ILabAddInfo;
  selectedLabCertificate: Array<ILabCertificate>;
}
export const payloadConvertor = ({
  lab,
  selectedLabCertificate,
}: PayloadConvertorProps): IUpdateLabShopPayload => {
  const payload: IUpdateLabShopPayload = {
    guid: lab?.guid || '',
    about: lab?.about,
    city: lab?.city?.id,
    title: lab?.title,
    land_line: lab?.land_line,
    location: `POINT (${lab?.location?.lng} ${lab?.location?.lat})`,
    owner_name: lab?.owner_name,
    phone_number: lab?.phone_number,
    state: String(lab?.state?.id),
    activity_field: lab?.activity_field?.toString() || '',
    lab_tests: lab?.lab_tests || '',
    certificate: selectedLabCertificate.map(x => x.id).toString(),
    activity_city: lab?.activity_city?.map(item => item.id).toString() || '',
    activity_state: lab?.activity_state?.map(item => item.id).toString() || '',
    establishment_year: lab?.establishment_year || '',
    from_hour: lab?.from_hour || '',
    to_hour: lab?.to_hour || '',
    result_from_day: lab?.result_from_day || '',
    result_to_day: lab?.result_to_day || '',
    speciality: lab?.speciality || '',
    owner_age: lab?.owner_age,
  };
  typeof lab?.license !== 'string' &&
    lab?.license &&
    Object.assign(payload, {license: lab?.license});
  typeof lab?.logo !== 'string' &&
    lab?.logo &&
    Object.assign(payload, {logo: lab?.logo});
  typeof lab?.national_card !== 'string' &&
    lab?.national_card &&
    Object.assign(payload, {national_card: lab?.national_card});
  return payload;
};
